/**
 * Ordinal numbers for schedule copy — "the 8th of the month", "the 2nd week".
 * Shared so web's recurrence summaries and native's cron editor spell the same
 * number the same way.
 */

/** The suffix alone: `8` → "th". 11–13 take "th" despite ending in 1, 2, 3. */
export const ordinalSuffix = (n: number): string => {
  const abs = Math.abs(Math.trunc(n));
  if (abs % 100 >= 11 && abs % 100 <= 13) return "th";
  switch (abs % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

/** The number with its suffix: `8` → "8th". */
export const ordinal = (n: number): string => `${n}${ordinalSuffix(n)}`;
